import React from "react";

function Services() {
  return (
    <section className="services">
      <h2>Our Services</h2>

      <div className="services-grid">
        <div className="card">
          <h3>Sourcing</h3>
          <p>
            We find the best talent in Sri Lanka based on your specific needs.
          </p>
        </div>

        <div className="card">
          <h3>Onboarding</h3>
          <p>
            We set up the legal contracts and remote infrastructure.
          </p>
        </div>

        <div className="card">
          <h3>Support</h3>
          <p>
            We provide ongoing HR and payroll management.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;